import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	everyoneElse: {
		id: 'servicedesk-request-type-security.config-button.config-modal.request-type-permissions-config.principal-list.everyone-else',
		defaultMessage: 'Everyone else',
		description:
			'Displayed when viewing the request type permission list to show the permission on everyone else.',
	},
});
